import { ref } from 'vue'

interface ConfirmOptions {
  title: string
  message: string
  type?: 'default' | 'danger'
  confirmText?: string
  cancelText?: string
}

const isVisible = ref(false)
const options = ref<ConfirmOptions>({
  title: '',
  message: ''
})

let resolvePromise: ((value: boolean) => void) | null = null

export function useConfirm() {
  const confirm = (opts: ConfirmOptions): Promise<boolean> => {
    options.value = {
      type: 'default',
      confirmText: 'Confirmar',
      cancelText: 'Cancelar',
      ...opts
    }
    
    isVisible.value = true
    
    return new Promise((resolve) => {
      resolvePromise = resolve
    })
  }
  
  const handleConfirm = () => {
    isVisible.value = false
    if (resolvePromise) {
      resolvePromise(true)
      resolvePromise = null
    }
  }
  
  const handleCancel = () => {
    isVisible.value = false
    if (resolvePromise) {
      resolvePromise(false)
      resolvePromise = null
    }
  }
  
  return {
    isVisible,
    options,
    confirm,
    handleConfirm,
    handleCancel
  }
}

// Global confirm instance
const globalConfirm = useConfirm()

export const confirmDialog = globalConfirm.confirm
export const confirmState = {
  isVisible: globalConfirm.isVisible,
  options: globalConfirm.options,
  handleConfirm: globalConfirm.handleConfirm,
  handleCancel: globalConfirm.handleCancel
}